/**
 *  Given an array of filters, returns an array of filters that match name.
 *
 * @ignore
 * @param name - The market name
 * @param filters - Array of filters to match part of name
 * @param filteringType - String to indicate filtering option to be used
 * @returns {*}
 */
export const filter = (name, filters, filteringType) => {
  if (name === null) {
    return [];
  }
  let lName = name.toLowerCase();
  let names = lName.split("_").join(" ");

  const matched = filters.map((filter) => {
    switch (filteringType) {
      case "match":
        return filter === names ? filter : null;
      default:
        return names.includes(filter.toLowerCase()) ? filter : null;
    }
  });
  return matched.filter((filter) => typeof filter === "string");
};

export default filter;



// WEBPACK FOOTER //
// ./src/apis/content/filter.js